export interface IHomeController {
    
}

export class HomeController {

}